import { dateTimeFormatCache } from "./intlApi";

export const SECONDS_IN_DAY = 24 * 60 * 60;

export const formatIntlDateTime = ({
  time,
  hour12,
  timeZone,
  locale,
  ...rest
}) => {
  const options: any = {
    timeZone,
    ...rest,
  };

  if (hour12) {
    options.hourCycle = "h12";
  } else {
    options.hourCycle = "h23";
  }

  return dateTimeFormatCache(locale, options).format(time);
};
